import { AuthService } from 'src/app/core/services/auth.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthModalComponent } from 'src/app/components/auth-modal/auth-modal.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Capacitor } from '@capacitor/core';
import { ActionSheet, ActionSheetButtonStyle } from '@capacitor/action-sheet';
//import { SheetState } from 'ion-bottom-sheet';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnInit, OnDestroy {
  public isCollapsed = true;
  public isMobileWeb = false;
  public isMobile = false;
  public showMobileLogin = false;
  // public sheetState = SheetState.Docked;
  // public dockerBottomSheetHeight;
  public year: any;
  isSignup = false;
  subscriptionRef: Subscription;

  constructor(public dialog: MatDialog, private router: Router, private deviceService: DeviceDetectorService, private authService: AuthService, private bottomSheet: MatBottomSheet) {
    this.subscriptionRef = this.authService.currentUser.subscribe(user => {
      if (user?.userId && user?.userId.length > 0) {
        if (!user?.onboardingCompleted) {
          this.router.navigate(['/authentication/onboarding']);
        } else {
          if (user?.isInstructor) {
            this.router.navigate(['/instructor']);
          } else {
            this.router.navigate(['/home']);
          }
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.subscriptionRef.unsubscribe();
  }

  ngOnInit(): void {
    const date = moment();
    this.year = date.year();
    //  this.dockerBottomSheetHeight = window.innerHeight - 100;
    const isMobileDevice = this.deviceService.isMobile();
    const isTabletDevice = this.deviceService.isTablet();
    const isNative = Capacitor.isNativePlatform();
    if ((isMobileDevice) && !isNative) {
      this.isMobileWeb = true;
    }
    if (isMobileDevice /*|| isTabletDevice || isNative*/) {
      this.isMobile = true;
    }
  }

  openAuth(isSignup: boolean) {
    this.isCollapsed = true;
    if (this.isMobile) {
      // setTimeout(() => {
      //   this.showMobileLogin = true;
      //   this.sheetState = SheetState.Docked;
      // }, 300);
      setTimeout(() => {
        this.bottomSheet.open(AuthModalComponent, { data: { isSignup: isSignup, isMobile: this.isMobile } });
      }, 300);
    } else {
      this.dialog.closeAll();
      let dialogRef = this.dialog.open(AuthModalComponent, {
        data: { isSignup: isSignup, isMobile: this.isMobile },
        position: { top: '100px' }
      });

      dialogRef.afterClosed().subscribe((x) => {

        dialogRef = null;
      });

    }
  }
}
